const messages = {
  title: 'Pristup odbijen',
  description: 'Nemate pristup ovom resursu',
  backHomeButton: 'Natrag na nadzornu ploču'
}

export default {
  messages
}
